export default () => ({
  trigger: {
    name: 'review_panel.view_review_panel',
    params: {},
  },
  config: {
    event: {
      name: 'view_content',
      params: {
        sub_feature: null,
        content: null,
        index: null,
        total_indices: null,
      },
    },
    nonInt: true,
  },
});
